import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'ramda'
import withStyle from './ListContainer.style.js'

const ListContainer = ({ className, style, children }) => (
  <div className={className} style={style}>
    {children}
  </div>
)

ListContainer.defaultProps = {
  column: false,
  doOffAxisMargins: true,
}

ListContainer.propTypes = {
  className: PropTypes.string,
  /** column or row */
  column: PropTypes.bool,
  /** on-axis margins are always suppressed at the ends (first/last). */
  doOffAxisMargins: PropTypes.bool,
  /** Custom button styles */
  style: PropTypes.object,
  /** may be empty.  node because element breaks some tests. */
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
}

export default compose(withStyle)(ListContainer)
